import React from "react"
import { useContent } from "@thoughtbot/superglue"

import { DeveloperDocsLayout, type DeveloperDocsPage } from "@javascript/components/developer-docs/DeveloperDocsLayout"
import { OverviewPage } from "@javascript/components/developer-docs/OverviewPage"

interface DeveloperContent {
  pages: DeveloperDocsPage[]
}

export default function Developer() {
  const { pages } = useContent<DeveloperContent>()

  return (
    <DeveloperDocsLayout pages={pages} currentHref="/developers">
      <OverviewPage />
    </DeveloperDocsLayout>
  )
}
